/**
 * Customer name to store on a line-item copy that is not tied to a location yet.
 *
 * `quotes_location_or_customer_check` requires `location_id` or a non-null
 * `customer_name`. A blank string satisfies that check. The quote form treats
 * blank as unset and asks for the new store before save.
 */
export function customerNameForUnassignedDuplicate(customerName: string | null | undefined): string {
  const trimmed = customerName?.trim();
  return trimmed ? trimmed : '';
}

/** Suggest the next unique document number when duplicating a quote or invoice. */
export function suggestDuplicateDocumentNumber(original: string, existingNumbers: Iterable<string>): string {
  const taken = new Set(existingNumbers);

  const suffixMatch = original.match(/^(.*)_(\d+)$/);
  if (suffixMatch) {
    const base = suffixMatch[1];
    let n = Number.parseInt(suffixMatch[2] ?? '0', 10) + 1;
    let candidate = `${base}_${n}`;
    while (taken.has(candidate)) {
      n += 1;
      candidate = `${base}_${n}`;
    }
    return candidate;
  }

  let candidate = `${original}-COPY`;
  if (!taken.has(candidate)) return candidate;

  let i = 2;
  while (taken.has(`${original}-COPY-${i}`)) {
    i += 1;
  }
  return `${original}-COPY-${i}`;
}
